import React, { useState } from 'react';

import { useDataProvider } from 'leeloo-react/component/hook/useDataProvider';

import { DataTableDefaultButton } from './DataTableDefaultButton';
import { DataTableButtonType } from '../../../model/dataTable/DataTableButtonType';

export function DataTableDeleteButton<T>(props: DataTableButtonType<T>) {
  const [isLoad, setIsLoad] = useState(false);
  const dp = useDataProvider();

  const fetchPromise = () => dp.delete!(props.resource, { id: props.row?.id, data: props.data });
  const fetchPromises = () => (props.rows as []).map((row: T & {id: any}) => dp.delete!(props.resource, { id: row.id, data: props.data }));

  const handleLoad = (newLoadState: boolean) => {
    setIsLoad(newLoadState);
  };

  return (
    <DataTableDefaultButton
      {...props}
      isLoad={isLoad}
      onClick={() => setIsLoad(true)}
      label="Supprimer"
      icon="trash-alt"
      fetchPromise={fetchPromise}
      fetchPromises={fetchPromises}
      handleLoad={handleLoad}
      messageFetchOne="Confirmez-vous la suppression de cet élément ?"
      messageFetchMultiples="Confirmez-vous la suppression de ces éléments ?"
      messageSuccess="Suppression effectuée avec succès"
    />
  );
}

DataTableDeleteButton.defaultProps = {
  variant: 'danger',
};
